import { createContext, useContext } from 'react';

export type NgTopologyConfiguration = {
  emsServerUrl: string;
  identityServerUrl: string;
  portalServerUrl: string;
  appleEedServerUrl: string;
};

export async function fetchNgTopology(): Promise<NgTopologyConfiguration> {
  const response = await fetch('/appsettings.json');
  if (!response.ok) {
    throw new Error(`No configuration returned. (HTTP ${response.status})`);
  }

  const settings = (await response.json()) as { NgTopology?: NgTopologyConfiguration } | null;
  const topology = settings?.NgTopology;
  if (!topology) {
    throw new Error('No NgTopology configuration found in appsettings.json.');
  }

  return topology;
}

export const TopologyContext = createContext<NgTopologyConfiguration | null>(null);

export function useTopology(): NgTopologyConfiguration {
  const topology = useContext(TopologyContext);
  if (!topology) {
    throw new Error('useTopology must be used within a TopologyContext provider');
  }

  return topology;
}
